import { taxMapKeyAdapter } from "@modernary/mui/components/taxMapKey";
import type { Well, WellFormKit } from "./well";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: Well) {
  entity._authRequestFields = ["id", "wellId", "statusMurn", "classMurn", "subClassMurn"] as (keyof Well)[];
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Well }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Well }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function getInitialData() {
  const result = {} as Well;
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Well) {
  if (data.latitudeLongitude) {
    (data as WellFormKit).latitudeLongitudeVal = {
      latitude: data.latitudeLongitude.coordinates[1],
      longitude: data.latitudeLongitude.coordinates[0],
    };
  }
  taxMapKeyAdapter(data as Well);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: WellFormKit) {
  if (data.latitudeLongitudeVal?.latitude && data.latitudeLongitudeVal?.longitude) {
    data.latitude = data.latitudeLongitudeVal.latitude;
    data.longitude = data.latitudeLongitudeVal.longitude;
  }
}
